'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateEntityData = exports.removeBlock = exports.insertAtomicBlock = exports.insertEntity = exports.applyEntity = exports.removeEntity = exports.applyBlock = exports.toggleStyle = exports.toggleBlock = exports.updateReadOnly = exports.updateEditorStateFromRaw = exports.updateEditorState = exports.setRef = exports.init = undefined;

var _ActionTypes = require('../constants/ActionTypes');

var init = exports.init = function init(editorName, config) {
  return {
    type: _ActionTypes.INIT,
    editorName: editorName,
    config: config
  };
};

var setRef = exports.setRef = function setRef(editorName, editorInstance) {
  return {
    type: _ActionTypes.SET_REF,
    editorName: editorName,
    editorInstance: editorInstance
  };
};

var updateEditorState = exports.updateEditorState = function updateEditorState(editorName, editorState) {
  return {
    type: _ActionTypes.UPDATE_EDITOR_STATE,
    editorName: editorName,
    editorState: editorState
  };
};

var updateEditorStateFromRaw = exports.updateEditorStateFromRaw = function updateEditorStateFromRaw(editorName, rawContent) {
  return {
    type: _ActionTypes.UPDATE_EDITOR_STATE_FROM_RAW,
    editorName: editorName,
    rawContent: rawContent
  };
};

var updateReadOnly = exports.updateReadOnly = function updateReadOnly(editorName, readOnly) {
  return {
    type: _ActionTypes.UPDATE_READ_ONLY,
    editorName: editorName,
    readOnly: readOnly
  };
};

var toggleBlock = exports.toggleBlock = function toggleBlock(editorName, blockName) {
  return {
    type: _ActionTypes.TOGGLE_BLOCK,
    editorName: editorName,
    blockName: blockName
  };
};

var toggleStyle = exports.toggleStyle = function toggleStyle(editorName, styleName) {
  return {
    type: _ActionTypes.TOGGLE_STYLE,
    editorName: editorName,
    styleName: styleName
  };
};

var applyBlock = exports.applyBlock = function applyBlock(editorName, blockName) {
  return {
    type: _ActionTypes.APPLY_BLOCK,
    editorName: editorName,
    blockName: blockName
  };
};

var removeEntity = exports.removeEntity = function removeEntity(editorName) {
  return {
    type: _ActionTypes.REMOVE_ENTITY,
    editorName: editorName
  };
};

var applyEntity = exports.applyEntity = function applyEntity(editorName, entityName, mutability, data) {
  return {
    type: _ActionTypes.APPLY_ENTITY,
    editorName: editorName,
    entityName: entityName,
    mutability: mutability,
    data: data
  };
};

var insertEntity = exports.insertEntity = function insertEntity(editorName, entityName, mutability, data) {
  var text = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : ' ';

  return {
    type: _ActionTypes.INSERT_ENTITY,
    editorName: editorName,
    entityName: entityName,
    mutability: mutability,
    data: data,
    text: text
  };
};

var insertAtomicBlock = exports.insertAtomicBlock = function insertAtomicBlock(editorName, entityName, mutability, data) {
  var text = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : ' ';

  return {
    type: _ActionTypes.INSERT_ATOMIC_BLOCK,
    editorName: editorName,
    entityName: entityName,
    mutability: mutability,
    data: data,
    text: text
  };
};

var removeBlock = exports.removeBlock = function removeBlock(editorName, blockKey) {
  return {
    type: _ActionTypes.REMOVE_BLOCK,
    editorName: editorName,
    blockKey: blockKey
  };
};

var updateEntityData = exports.updateEntityData = function updateEntityData(editorName, entityKey, data) {
  return {
    type: _ActionTypes.UPDATE_ENTITY_DATA,
    editorName: editorName,
    entityKey: entityKey,
    data: data
  };
};
//# sourceMappingURL=data:application/json;charset=utf8;base64,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



//////////////////
// WEBPACK FOOTER
// ../lib/actions/index.js
// module id = 586
// module chunks = 0